import { api } from '../apiClient';

/**
 * 서비스 등록 (#136)
 *
 * 전에는 등록 경로가 인증 없는 API 하나뿐이었고, 화면이 없어 사람이 등록할 수 없었다.
 * 이제 두 갈래다 — **둘 다 로그인해야** 부를 수 있다.
 *
 * - `submit()`  사용자가 자기 서비스를 신청한다 → `pending`, 슈퍼관리자가 승인
 * - `register()` 슈퍼관리자가 직접 등록한다 → 바로 `approved` 로 둘 수 있다
 */

/** 화면에서 받는 값. `metadata` 는 서버가 채운다 — 손으로 만들지 않는다 */
export interface ServiceRegisterInput {
  service_name: string;
  base_slug: string;
  version: string;
  service_url: string;
  service_description?: string;
  service_icon_url?: string;
  category?: string;
  contact_email?: string;
  contact_name?: string;
  is_public: boolean;
}

/** 등록 응답. `api_key` 는 서버 간 호출용이고 로그인 연동(client_id)과는 다른 것이다 */
export interface ServiceRegisterResult {
  service_slug: string;
  status: string;
  /** 슈퍼관리자가 등록할 때만 온다. 사용자 신청에는 없다(보안 점검 2026-10-20) */
  api_key: string | null;
  message: string;
  manifest_warnings: string[];
}

/** 내가 신청한 서비스. api_key 는 담기지 않는다 */
export interface MyService {
  service_slug: string;
  service_name: string;
  service_url: string | null;
  service_description: string | null;
  category: string | null;
  version: string | null;
  status: string;
  is_public: boolean;
  created_at: string;
  approved_at: string | null;
}

export const serviceRegistrationAPI = {
  /** 사용자가 신청한다. 언제나 등록대기(pending)로 남는다 */
  submit: (input: ServiceRegisterInput): Promise<ServiceRegisterResult> =>
    api.post('/services/register', input).then((response) => response.data),

  /** 내가 신청한 것과 그 상태 */
  listMine: (): Promise<MyService[]> =>
    api.get('/services/my').then((response) => response.data),

  /** 내 신청을 스스로 내린다. 승인된 서비스는 관리자만 내린다 */
  withdraw: (serviceSlug: string): Promise<{ message: string }> =>
    api.delete(`/services/my/${serviceSlug}`).then((response) => response.data),

  /** 슈퍼관리자가 직접 등록한다. `approveNow=false` 면 등록대기로 남는다 */
  register: (
    input: ServiceRegisterInput,
    approveNow = true,
  ): Promise<ServiceRegisterResult> =>
    api
      .post(`/admin/services?approve_now=${approveNow}`, input)
      .then((response) => response.data),
};
